import { render, staticRenderFns } from "./searchPopBDGL.vue?vue&type=template&id=27503a28&scoped=true&"
import script from "./searchPopBDGL.vue?vue&type=script&lang=ts&"
export * from "./searchPopBDGL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27503a28",
  null
  
)

export default component.exports